import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { getActiveOrderId } from 'redux/selectors/app';
import { getPickedMoments } from 'redux/selectors/photos';
import { getPrintType, getSpreadInfo } from 'redux/selectors/books';
import { getSpreadDesign, getSpreadDimensions } from 'redux/selectors/design';

import { Graphic, Moment } from 'components';

import { stringToCSSObject } from 'helpers/string';

import cx from 'classnames';
import styles from './styles.scss';

@connect((state, props) => ({
  appWidth: state.getIn(['app', 'dimensions', 'width']),
  appHeight: state.getIn(['app', 'dimensions', 'height']),
  info: getSpreadInfo(state, props.id),
  design: getSpreadDesign(state),
  spreadDimensions: getSpreadDimensions(state),
  pickedMoments: getPickedMoments(state),
  previews: state.getIn(['app', 'previews', getActiveOrderId(state)], Map()),
  printType: getPrintType(state),
}))
export default class Spread extends React.PureComponent {
  static contextTypes = {
    canEdit: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      wrapper: null,
      scale: 1,
    };
  }

  componentDidMount() {
    const wrapper = ReactDOM.findDOMNode(this.wrapper);
    this.updateScale(this.props, wrapper);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.spreadDimensions !== this.props.spreadDimensions ||
      nextProps.appWidth !== this.props.appWidth ||
      nextProps.appHeight !== this.props.appHeight
    ) {
      this.updateScale(nextProps);
    }
  }

  updateScale(props = this.props, wrapper = this.state.wrapper) {
    const { spreadDimensions } = props;

    const newState = {
      wrapper: wrapper,
    };

    // Get dimensions
    const width = wrapper.offsetWidth;
    const height = wrapper.offsetHeight;

    const spreadRatio = spreadDimensions.get('width') / spreadDimensions.get('height');
    const wrapperRatio = width / height;

    // Scale by height
    if (spreadRatio < wrapperRatio) {
      newState.scale = height / spreadDimensions.get('height');
    }
    // Scale by width
    else {
      newState.scale = width / spreadDimensions.get('width');
    }

    if (newState.wrapper !== this.state.wrapper || this.state.scale !== newState.scale) {
      this.setState(newState);
    }
  }

  render() {
    const { info, spreadDimensions, pickedMoments, previews, design, printType } = this.props;
    const { canEdit } = this.context;
    const { scale } = this.state;

    const classes = cx(styles.wrapper, {
      [styles.disableEditing]: !canEdit,
    });

    const spreadLabel = info && info.get('label');
    const spreadStyle = {
      height: Math.round(spreadDimensions.get('height') * scale) + 'px',
      width: Math.round(spreadDimensions.get('width') * scale) + 'px',
      ...stringToCSSObject(design.get('css', '')),
    };
    const pageWidth = spreadDimensions.get('width') / 2;

    const moments = info.get('moments', null);
    const designMoments = design.get('moments', null);
    const graphics = design.get('graphics', null);
    return (
      <div className={classes}>
        <div className={styles.spreadWrapper} ref={c => (this.wrapper = c)}>
          <div className={styles.spread} style={spreadStyle}>
            {graphics
              ? graphics.map(graphic => <Graphic key={graphic.get('id')} scale={scale} graphic={graphic} />).toArray()
              : null}

            {moments && designMoments
              ? moments
                  .map(moment => (
                    <Moment
                      key={moment.get('id')}
                      index={designMoments.findIndex(m => m.get('id') === moment.get('id'))}
                      scale={scale}
                      info={moment}
                      picked={pickedMoments.get(moment.get('id'), Map())}
                      preview={previews.get(moment.get('id'), Map())}
                      design={designMoments.find(m => m.get('id') === moment.get('id'))}
                      pageWidth={pageWidth}
                    />
                  ))
                  .toArray()
              : null}
            {printType === 'book' ? <div className={styles.fold} /> : null}
          </div>
        </div>
        <div className={styles.label}>{spreadLabel}</div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/spread/index.js